import type * as React from 'react';
import { Index } from 'react-instantsearch-dom';

import Retracked from 'js/app/retracked';

type Props = {
  indexName: unknown;
  indexPosition?: number;
};

/**
 * @deprecated
 */
const TrackedIndex = Retracked.createTrackedContainer<React.PropsWithChildren<Props>>((props: Props) => {
  return {
    indexName: props.indexName,
    indexPosition: props.indexPosition || 0,
  };
})(Index);

export default TrackedIndex;
